let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("joJy8"), load("aHE9G"), load("np2ZB")]).then(() => parcelRequire('6i2Ga'));